export default {
  state: {
    faq: [
      {
        title:
          'Does your company have formal documentation of principles that guide on how to set up your technological resources?',
        content:
          'We maintain configuration, administrator and user documentation. The guides can also be made available as part of a product evaluation.',
      },
      {
        title:
          'Is there a periodic (at least annual) review of your Business Resiliency procedures?',
        content:
          'Our BCP / DRP plans are internal are required by the Business Continuity and Disaster Recovery Policy to be reviewed annually.',
      },
      {
        title:
          'Do you test your backup or redundancy mechanisms at least annually?',
        content:
          'Acme tests our backup and restoration capabilities at least quarterly. Any identified issues will be tracked in internal tickets for resolution. We have also documented and tested controls related to backup and redundancy as part of our SOC2 and ISO2700x certificates. For more information, see: https://www.acme.com/trust/compliance .',
      },
      {
        title:
          'Pursuant to local laws, regulations, ethics, and contractual constraints, are all employment candidates, contractors, and involved third parties subject to background verification?',
        content:
          'New Acme employees are required to complete a background check. Newly hired employees as a result of an acquisition have a background check performed after the acquisition date. A criminal check is run on all new hires and independent contractors - education verification, employment verification, or credit checks are added in if the role or level of the position requires it. We perform full background checks for senior executive and accounting roles.',
      },
      {
        title:
          'Are employees made aware of what actions could be taken in the event of a violation via their policies and procedures?',
        content:
          "Acme's Security Policy outlines potential actions if in violation of the Policy, up to and including termination.",
      },
      {
        title:
          'Is physical and logical user access to audit logs restricted to authorized personnel?',
        content:
          'Acme restricts ability to view and read audit logs to authorized personnel on our centralized logging platform.',
      },
      {
        title: 'Are Network Intrusion Detection capabilities employed?',
        content:
          'We have deployed IDS at our office sites and our cloud hosting environment (AWS). For the Acme Cloud Platform, logs are forwarded with our Security Analytics Platform (Splunk). At the Cloud Platform container level, file integrity is maintained as the instances are non-modifiable.',
      },
      {
        title: 'What cryptographic frameworks do you use to store passwords?',
        content:
          'Passwords for Acme internal users are encrypted and protected using standard Microsoft Active Directory frameworks and technologies.',
      },
      {
        title:
          'Do you logically and physically segregate production and non-production environments?',
        content:
          'We maintain logical and physical separation of our AWS production and AWS non-production (testing) environments and these environments are isolated. Our staging environment is logically separated (but not physically separated) but is managed under production-grade change control and access processes.',
      },
      {
        title:
          'Are all security events (authentication events, SSH session commands, privilege elevations) in production logged?',
        content:
          'Key system logs are forwarded from each system to a centralized log platform, where logs are read-only. The Acme Security Team creates alerts on our Security Analytics Platform (Splunk) and monitors for indicators of compromise. Our teams use the Platform to monitor for availability or performance issues. Logs are retained for 30 days in hot backup, and 365 days in cold backup.',
      },
      {
        title:
          'Are electronic systems used to transmit, process or store Scoped Systems and Data?',
        content:
          'End user devices are only used for support purposes, all other access is through our applications.',
      },
    ],
  },

  getters: {
    GET_FAQ(state) {
      return state.faq
    },
  },
}
